var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/api/schema";
export const createApiKey = fetcher.path("/api/users/{user_id}/api_key").method("post").create();
export const deleteUser = fetcher.path("/api/users/{user_id}").method("delete").create();
export const fetchQuotaUsages = fetcher.path("/api/users/{user_id}/usage").method("get").create();
export const recalculateDiskUsage = fetcher.path("/api/users/current/recalculate_disk_usage").method("put").create();
export const recalculateDiskUsageByUserId = fetcher
    .path("/api/users/{user_id}/recalculate_disk_usage")
    .method("put")
    .create();
export const sendActivationEmail = fetcher.path("/api/users/{user_id}/send_activation_email").method("post").create();
export const undeleteUser = fetcher.path("/api/users/deleted/{user_id}/undelete").method("post").create();
const getUsers = fetcher.path("/api/users").method("get").create();
export function getAllUsers() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getUsers({});
        return data;
    });
}
